import $ from 'jquery';

const slideProgress = {
		
    init: function() {
        this.$region = $('body').attr('data-js-region');
        this.$progressBar = $('[data-js-progress="training-bar"]');
        this.$progressText = $('[data-js-progress="training-num"]');
        this.getProgress();
    },
    
    getProgress: function() {
        
        // retreives the decimal value of the percentage of the furthest slide the user has seen. E.g if the user has been to slide 5 out of 10, the decimal we receive back is 0.5 (50%);
        $.get(this.$region + '/slide-progress',function(data) {
            slideProgress.setProgress(data.data.progress);
        });
    },
    
    setProgress: function(data) {
        // converts decimal into integer
        this.percentage = Math.round(data * 100) + '%';
        
        this.$progressBar.css('width',this.percentage);
        this.$progressText.html(this.percentage);
    }
}

$(document).ready(() => {
    if ($('[data-js-progress="training-bar"]').length) {
        slideProgress.init();
    }
})